import { combineReducers } from 'redux'

import app from '@services/store/reducers/app'

import landingZones from './landingZones/reducer'
import landingZoneGroups from './landingZones/Groups/reducer'
import landingZoneMigration from './landingZones/Migration/reducer'
import landingZoneServices from './landingZones/Services/reducer'
import landingZoneTags from './landingZones/Tags/reducer'
import landingZoneTeams from './landingZones/Teams/reducer'

import serviceHealth from './serviceHealth/reducer'
import firewallLogs from './firewallLogs/reducer'

export const reducers = {
    app,
    landingZones,
    landingZoneGroups,
    landingZoneMigration,
    landingZoneServices,
    landingZoneTags,
    landingZoneTeams,
    serviceHealth,
    firewallLogs
}

const rootReducer = combineReducers(reducers)
export default rootReducer